import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { Button, Input } from '@tecsinapse/cortex-react'
import clsx from 'clsx'
import React, { useState } from 'react'
import { SlReload } from 'react-icons/sl'
import { useSuperAdminQueryHandler } from '../hooks/use-query-handler'
import { getLabel } from '@/core/utils/global-labels'

export const Sincronizacao = () => {
  const {
    sincronizarIdentityProvider,
    handleSincronizarGrupos,
    handleSincronizarUsuarios,
    handleSincronizarDealers
  } = useSuperAdminQueryHandler()
  const [emailUsuario, setEmailUsuario] = useState('')

  return (
    <div className={'grid grid-cols-2 gap-deca'}>
      <Button onClick={handleSincronizarGrupos}>
        <Trans>Sincronizar {getLabel('label.grupos')}</Trans>
      </Button>

      <Button onClick={handleSincronizarDealers}>
        <Trans>Sincronizar {getLabel('label.dealers')}</Trans>
      </Button>

      <Button onClick={handleSincronizarUsuarios}>
        <Trans>Sincronizar Usuários</Trans>
      </Button>

      <Input.Face>
        <Input.Box
          value={emailUsuario}
          label={t`Atualizar Identity Provider Links`}
          placeholder={t`E-mail do usuário`}
          onChange={e => setEmailUsuario(e.target.value)}
          name='emailUsuario'
        />
        <Input.Right>
          <SlReload
            aria-label='sincronizar'
            className={clsx(
              {
                'hover:cursor-pointer hover:text-primary-dark text-primary-medium':
                  emailUsuario
              },
              { 'text-secondary-medium': !emailUsuario }
            )}
            onClick={async () => {
              if (emailUsuario) {
                await sincronizarIdentityProvider({
                  variables: { emailUsuario }
                })
              }
            }}
          />
        </Input.Right>
      </Input.Face>
    </div>
  )
}
